import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { SaleDetailSchema } from './sale.contract'
import type { SaleDetail } from './sale.contract'
import { salesKeys } from './sale.queries'

export async function requestSaleRefund(saleId: string, reason?: string): Promise<SaleDetail> {
  const trimmedReason = reason?.trim()
  return SaleDetailSchema.parse(
    await apiFetch<unknown>(`/sales/${saleId}/refund`, {
      method: 'POST',
      ...(trimmedReason ? { body: { reason: trimmedReason } } : {}),
    }),
  )
}

export type RequestSaleRefundInput = {
  saleId: string
  reason?: string
}

export function useRequestSaleRefundMutation(journeySaleId: string | null) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ saleId, reason }: RequestSaleRefundInput) => requestSaleRefund(saleId, reason),
    onSuccess: async (sale) => {
      queryClient.setQueryData(salesKeys.detail(sale.id), sale)
      await Promise.all([
        ...(journeySaleId
          ? [queryClient.invalidateQueries({ queryKey: salesKeys.detail(journeySaleId) })]
          : []),
        queryClient.invalidateQueries({ queryKey: ['sales', 'list'] }),
      ])
    },
  })
}
